import React from "react";
import withAnimation from "../../../hooks/withAnimation";
import { routeNames } from "../../../routes/routeNames";
import { FaExternalLinkAlt } from "react-icons/fa";
import ContactButton from "../../MainComponents/ContactButton";

const AppointmentSection = () => {
  return (
    <section className="bg-primary py-12">
      <div className="container mx-auto px-4 text-white">
        <h2 className="text-4xl font-bold mb-8 text-center sm:text-left">
          Get on the Path to Pain-Free Living
        </h2>
        <div className="space-y-8">
          <div className="flex flex-col sm:flex-row items-start">
            <div className="bg-white text-primary font-bold rounded-full w-10 h-10 flex items-center justify-center mb-4 p-2 sm:mb-0 sm:mr-4">
              1
            </div>
            <div>
              <h3 className="text-2xl font-bold">
                Book Online or Call Us Today
              </h3>
              <p className="mt-2 text-justify">
                Booking an appointment is easy and convenient. Simply visit our{" "}
                <a href="#" className="text-secondary underline">
                  booking page
                </a>{" "}
                and select a time slot that works for you or give us a call on{" "}
                <a
                  href="tel:+1 (226) 368-1309"
                  className="text-secondary underline"
                >
                  +1 (226) 368-1309
                </a>{" "}
                to schedule an appointment over the phone. Our friendly staff
                will be more than happy to help you.
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-start">
            <div className="bg-white text-primary font-bold rounded-full w-10 h-10 flex items-center justify-center mb-4  sm:mb-0 sm:mr-4">
              2
            </div>
            <div>
              <h3 className="text-2xl font-bold">
                Receive a Custom Care Program
              </h3>
              <p className="mt-2 text-justify">
                We'll take the time to understand your unique situation and
                develop a custom program tailored to your needs and goals. Our
                team of experienced therapists will work with you to help you
                achieve your goals.
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-start">
            <div className="bg-white text-primary font-bold rounded-full w-10 h-10 flex items-center justify-center p-2 mb-4 sm:mb-0 sm:mr-4">
              3
            </div>
            <div>
              <h3 className="text-2xl font-bold">
                Accomplish Your Health Goals and Live Pain-Free!
              </h3>
              <p className="mt-2 text-justify">
                Your custom program is designed to help you achieve your desired
                outcomes as quickly and effectively as possible. Whether you're
                looking to manage your pain, improve your performance in
                recreation or sport, or simply live a more active and fulfilling
                life, our team is here to support you every step of the way.
              </p>
            </div>
          </div>
        </div>
        <ContactButton
          mainContStyle={
            "mt-8 flex flex-col justify-start sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4"
          }
          bookOnlinestyle={
            "bg-orange text-white py-4 px-8 rounded-full font-semibold text-center"
          }
          callButtonStyle={
            "bg-transparent text-white italic font-bold text-lg underline"
          }
        />
      </div>
    </section>
  );
};

export default withAnimation(AppointmentSection);
